import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    FormFieldComponentProps,
    ExtendedFieldId,
    FieldContent,
    Validator,
    setCustomValidator,
    ExtendedErrorId,
} from '@sheerid/jslib';

import { CheckBoxInputComponent } from '../checkboxComponent/CheckboxComponent';

export const ParentalConsentComponent = ({
    isErrored,
    isRequired,
    onChange,
    value = true || false,
}: FormFieldComponentProps) => {
    const parentalConsentFieldId: ExtendedFieldId = 'parentalConsent';

    const getOptInValidationError: Validator = (fieldContentValue: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidParentalConsent';
        if (isRequired && !fieldContentValue) {
            return invalidError;
        }
        return null;
    };

    setCustomValidator('parentalConsent', getOptInValidationError);

    return (
        <div className="sid-field sid-opt-in">
            <div className="sid-l-space-top-md" />
            <label htmlFor={parentalConsentFieldId}>
                <div className="sid-l-position">
                    <div className="sid-checkbox-container">
                        <div className="sid-checkbox">
                            <CheckBoxInputComponent
                                isErrored={isErrored}
                                onChange={onChange}
                                value={value}
                            />
                        </div>
                        <div className="sid-checkbox__label">
                            <FormattedHTMLMessage
                                id="custom.confirmParentalConstent"
                                defaultMessage="Confirms that the consent of the parent or guardian has been obtained."
                            />
                        </div>
                        { isErrored
                            ? (
                                <div className="sid-field-error">
                                    <FormattedHTMLMessage
                                        id="custom.errorId.invalidParentalConsent"
                                        defaultMessage="Required field"
                                    />
                                </div>
                            )
                            : null}
                    </div>
                </div>
            </label>
        </div>
    );
};
